import styled from "@emotion/styled";

import { ArticleCommentsTrigger } from "scmp-app/components/article/article-comments-trigger";
import { CountMessage } from "scmp-app/components/article/article-comments-trigger/button/styles";
import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

export const Container = styled.div<ResponsiveStyledProps>`
  ${responsiveStyles}
`;

export const StyledArticleCommentsTrigger = styled(ArticleCommentsTrigger)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  inline-size: 36px;
  block-size: 36px;
  margin-inline-end: 0;

  ${CountMessage} {
    inset-block-start: 0;
  }
`;
